<template>
  <div class="baiduQueue">
    <div class="box">
      <div class="b1">发布职位</div>
      <div class="b2">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
            <el-form-item label="职位名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入职位名称"></el-input>
            </el-form-item>
            <el-form-item label="职位介绍" prop="description">
                <el-input v-model="ruleForm.description" placeholder="请输入职位介绍"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="薪资范围" prop="salary">
                        <el-input v-model="ruleForm.salary" placeholder="请输入薪资范围"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <div style="height:20px;"></div>
                </el-col>
                <el-col :span="11">
                   <el-form-item label="福利待遇" prop="premium">
                        <el-input v-model="ruleForm.premium" placeholder="请输入福利待遇"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="工作年限" prop="experience">
                        <el-input v-model="ruleForm.experience" placeholder="请输入工作年限"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <div style="height:20px;"></div>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="学历要求" prop="education">
                        <el-input v-model="ruleForm.education" placeholder="请输入学历要求"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="公司名称" prop="orgaName">
                <el-input v-model="ruleForm.orgaName" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <div class="btn" @click="submitForm('ruleForm')">提交</div>
            
        </el-form>
      </div>
    </div>
    <show ref="show"></show>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item: {},
      ruleForm: {
        name: '',
        description:'',
        salary:'',
        premium:'',
        experience:'',
        education:'',
        orgaName:''

    },
    orga:{},
    rules: {
          name: [
            { required: true, message: '请输入职位名称', trigger: 'blur' }
          ],
          description: [
            { required: true, message: '请输入职位介绍', trigger: 'blur' }
          ],
          salary:[
            { required: true, message: '请输入薪资范围', trigger: 'blur' }
          ],
          premium:[
              { required: true, message: '请输入福利待遇', trigger: 'blur' }
          ],
          experience:[
              { required: true, message: '请输入工作年限', trigger: 'blur' }
          ],
          education:[
              { required: true, message: '请输入学历要求', trigger: 'blur' }
          ],
          orgaName:[
              { required: true, message: '请先申请企业', trigger: 'blur' }
          ]
        }
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
      this.$axios.post(`/do_oper_job`,this.$qs.stringify({crud:-1,aid:Cookie.get('id')})).then(res => {
            if(res.data.data.oid==-1){
                this.$refs.show.click()
                this.$router.go(-1)
                return;
            }else{
                this.orga=res.data.data
                this.ruleForm.orgaName=res.data.data.orgName
            }
        })
    },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj={
                crud:1,
                jobJson:JSON.stringify({
                    title:this.ruleForm.name,
                    description:this.ruleForm.description,
                    salary:this.ruleForm.salary,
                    experience:this.ruleForm.experience,
                    education:this.ruleForm.education,
                    premium:this.ruleForm.premium,
                    oid:this.orga.oid
                })
            }
            this.$axios.post(`/do_oper_job`,this.$qs.stringify(obj)).then(res=>{
                if(res.data.errCode==0){
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    setTimeout(()=>{
                        this.$router.go(-1)
                    },500)
                }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
  },

  mounted() {
    this.getData();
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue {
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  .box {
    width: 1200px;
    margin: 0 auto;
    height: 990px;
    background: #ffffff;
    border: 1px solid rgba(204, 204, 204, 0.5);
    position: relative;
    .b1 {
      width: calc(100% - 32px);
      height: 60px;
      background: #f3f3f3;
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      padding-left: 32px;
      line-height: 60px;
    }
    .b2 {
      width: calc(100% - 60px);
      padding: 20px 30px 30px;
      height: 930px;
      
    }
  }
}
.btn{
    width: 140px;
height: 38px;
background: #198AFA;
border-radius: 2px;
text-align: center;
line-height: 38px;
font-size: 16px;
font-family: SourceHanSansCN-Medium, SourceHanSansCN;
font-weight: 500;
color: #FFFFFF;
margin-top: 50px;
cursor: pointer;
}
.el-form-item{
    text-align: center;
    /deep/ .el-form-item__label{
        text-align: left;
        font-size: 18px;
font-family: SourceHanSansCN-Bold, SourceHanSansCN;
font-weight: bold;
color: #333333;
    }
    /deep/ .el-form-item__content{
        margin-left: 0 !important;
        .el-input,.el-textarea{
            width: 100%;
            .el-input__inner,.el-textarea__inner{
                border: none;
                font-size: 20px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #666666;
padding: 0;
            }
        }
    }
}
</style>  


// WEBPACK FOOTER //
// src/pages/applyRecruitment/index.vue